export default __webpack_public_path__ + "static/media/background.849e7282.jpg";